var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgShare = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4792 8.45833C10.6862 8.45833 9.95931 8.76986 9.42122 9.27018L6.02279 7.57096C6.03223 7.46712 6.04167 7.35384 6.04167 7.25C6.04167 7.14616 6.03223 7.03288 6.02279 6.92904L9.42122 5.22982C9.95931 5.73014 10.6862 6.04167 11.4792 6.04167C13.1501 6.04167 14.5 4.69173 14.5 3.02083C14.5 1.34994 13.1501 0 11.4792 0C9.80827 0 8.45833 1.34994 8.45833 3.02083C8.45833 3.12467 8.46777 3.23796 8.47721 3.3418L5.07878 5.04102C4.54069 4.54069 3.8138 4.22917 3.02083 4.22917C1.34993 4.22917 0 5.5791 0 7.25C0 8.9209 1.34993 10.2708 3.02083 10.2708C3.8138 10.2708 4.54069 9.95931 5.07878 9.45898L8.47721 11.1582C8.46777 11.262 8.45833 11.3753 8.45833 11.4792C8.45833 13.1501 9.80827 14.5 11.4792 14.5C13.1501 14.5 14.5 13.1501 14.5 11.4792C14.5 9.80827 13.1501 8.45833 11.4792 8.45833Z",
    fill: "#6E5F5F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/share.3317482f.svg";
export { ForwardRef as ReactComponent };